<template>
    <div id="mMobileFooter-container" class="mMobileFooter-container">
        <div class="mLogoMobile-container">
            <img class="imgLogoFooterMobile" :src="logoIconMobile" alt="Nueva Tecate 0.0, perfecta para disfrutar con tus comidas favoritas" />
        </div>
        <div class="mPrivacyMobileFooter-container">
            <h2 class="privacyMobileFooter clickable" @click="popUpModal('terms') & footerGA4Click('click', 'terminos y condiciones', 'footer')">
                Términos y Condiciones
            </h2>
            <!-- <span class="privacyMobileFooter bar">|</span> -->
            <h2 class="privacyMobileFooter clickable" @click="popUpModal('politics') & footerGA4Click('click', 'politica de privacidad', 'footer')">
                Aviso de Privacidad
            </h2>
            <!-- <span class="privacyMobileFooter bar">|</span> -->
            <h2 class="privacyMobileFooter clickable" @click="popUpModal('cookies') & footerGA4Click('click', 'politica de cookies', 'footer')">
                Política de Cookies
            </h2>
            <h2 v-if="showInfoOption" class="privacyMobileFooter clickable" @click="(showModalInfo = true) & footerGA4Click('click', 'informacion del producto', 'footer')">
                Información del producto
            </h2>
        </div>
        <div class="social-networksFooter">
            <a id="facebookFooter" class="social-iconFooter" target="_blank" rel="noopener" href="https://www.facebook.com/people/Tecate00/100083628819714/"
                @click="socialClick('Facebook', 'Interaction') & socialGA4Click('click', 'redes sociales :: facebook', 'footer')">
                <img :src="fbIconImage" alt="Facebook" />
            </a>
            <a id="instagramFooter" class="social-iconFooter" target="_blank" rel="noopener" href="https://www.instagram.com/tecate0.0/"
                @click="socialClick('Instagram', 'Interaction') & socialGA4Click('click', 'redes sociales :: instagram', 'footer')">
                <img :src="inIconImage" alt="Instagram" />
            </a>
            <a id="pinterestFooter" class="social-iconFooter" target="_blank" rel="noopener" href="https://www.pinterest.com.mx/Tecate00/"
                @click="socialClick('Pinterest', 'Interaction') & socialGA4Click('click', 'redes sociales :: pinterest', 'footer')">
                <img :src="pintIconImage" alt="Pinterest" />
            </a>
            <a id="twitterFooter" class="social-iconFooter" target="_blank" rel="noopener" href="https://twitter.com/tecatecerocero"
                @click="socialClick('Twitter', 'Interaction') & socialGA4Click('click', 'redes sociales :: twitter', 'footer')">
                <img :src="twIconImage" alt="Twitter" />
            </a>

        </div>
        <Modal v-if="showModal" v-bind:wichModal="wichModal" @close="showModal = false" />
        <ModalInfo v-if="showModalInfo" @close="showModalInfo = false"></ModalInfo>
    </div>
</template>

<script>
import Modal from "@/components/Modal";
import ModalInfo from "@/components/ModalInfoProduct";
import { mapActions, mapGetters } from "vuex";
import logoIconMobile from "@/assets/TECATELOGO.png";
import tagFunctions from '@/utils/tagFunctions.js'
import icon from "@/assets/TECATELOGO.png";
import fbIcon from "@/assets/redes-sociales/FACEBOOK.png";
import inIcon from "@/assets/redes-sociales/INSTAGRAM.png";
import twIcon from "@/assets/redes-sociales/TWITTER.png";
import pintIcon from "@/assets/redes-sociales/PINTEREST.png";

const utm1 = {
  utm_content: "QR_AvisoAlcohol",
  utm_medium: "PopUp",
  utm_source: "Lata-Tecate00",
};

export default {

    name: "MobileFooterHome.vue",

    computed: {
        ...mapGetters(["getActiveSection"]),
    },

    methods: {
        ...mapActions({
            setActiveSection: "setActiveSection",
        }),
        socialClick(socialNetwork, action) {
            tagFunctions.evSocialNetworkPush(socialNetwork, action)
            fbq('trackCustom', 'RedSocial'+socialNetwork);
        },
        socialGA4Click(action, element, section) {
            tagFunctions.user_interactionPush(action, element, section)
        },
        footerGA4Click(action, element, section) {
            tagFunctions.user_interactionPush(action, element, section);
        },
        openMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
        selectHomeOption(option) {
            this.setActiveSection({
                willScroll: true,
                section: option,
            });
        },
        selectMobileOption(option) {
            this.setActiveSection({
                willScroll: true,
                section: option,
            });
            this.$router.push({ path: option }).catch(err => {
                // Ignore the vuex err regarding  navigating to the page they are already on.
                if (
                    err.name !== 'NavigationDuplicated' &&
                    !err.message.includes('Avoided redundant navigation to current location')
                ) {
                    // But print any other errors to the console
                    throw err;
                }
            });
            this.openMenu();
        },
        popUpModal(modalType) {
            this.showModal = true;
            this.wichModal = modalType;
        },
    },

    data() {
        return {
            showModal: false,
            wichModal: "terms",
            showModalInfo: false,
            showInfoOption: false,
            isMenuOpen: false,
            icon,
            fbIconImage: fbIcon,
            twIconImage: twIcon,
            inIconImage: inIcon,
            pintIconImage: pintIcon,
            scrollingDown: false,
            logoIconMobile
        };
    },

    mounted() {
        const { utm_source, utm_medium, utm_content } = this.$route.query;
        if (
        utm1["utm_source"] === utm_source &&
        utm1["utm_content"] === utm_content &&
        utm1["utm_medium"] === utm_medium
        ) {
        setTimeout(() => {
            this.showInfoOption = true;
        }, 3000);
        }
        var lastScrollTop = window.pageYOffset;
        window.addEventListener("scroll", () => {
            var st = window.pageYOffset || document.documentElement.scrollTop;
            if (st > lastScrollTop) {
                // downscroll code
                this.scrollingDown = true;
            } else {
                // upscroll code
                this.scrollingDown = false;
            }
            lastScrollTop = st <= 0 ? 0 : st;
        }, false);
    },

    components: {
        Modal,
        ModalInfo
    }
}
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/MobileFooterHome.scss";
</style>